import {
  Card,
  H1,
  Box,
  H5,
  P,
  Stack,
  Text,
  Spinner,
  Inline,
  Button
} from "@adfenix/alexandria";
import { useMutation, useQuery } from "@tanstack/react-query";
import { EmailServiceApi } from "api/services";
import { toast } from "react-toastify";
import { Table } from "components/Datatable";
import Page from "components/Page";
import { useParams } from "react-router-dom";

export const PublicDomainPage = () => {
  const { domainId } = useParams<"domainId">();

  if (!domainId) throw "Domain id is required";

  const {
    domainAuthentication: {
      publicV1DomainAuthenticationInstructionsDetail: getInstructions,
      publicV1DomainAuthenticationStatusDetail:
        checkDomainAuthenticationSetupStatus
    }
  } = EmailServiceApi;

  const { data, isFetching } = useQuery(["domain-instructions", domainId], () =>
    getInstructions(domainId!)
  );
  const { mutateAsync, isLoading: isSubmitting } = useMutation(
    checkDomainAuthenticationSetupStatus
  );

  const handleVerifyDomainAuthentication = async () => {
    try {
      const res = await mutateAsync(domainId);
      if (res.isValid) {
        toast.success("Domain authentication set up correctly");
      } else {
        toast.error(
          "Domain authentication is not correctly set up, please check your details or if you have set it up recetly, come back later"
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong verifying the domain");
    }
  };

  if (isFetching) {
    return (
      <Page centered>
        <Spinner centered />
      </Page>
    );
  }

  return (
    <Page centered fullWidth topPadding={false}>
      <Inline justifyContent="space-between">
        <H1>Setup Domain Authentication DNS Records</H1>
        <Button
          variant="secondary"
          logLabel="verify-domain-authentication"
          isLoading={isSubmitting}
          onClick={handleVerifyDomainAuthentication}
        >
          Verify
        </Button>
      </Inline>

      <Card p={["m", "xl4", "xl4"]} style={{ marginTop: "56px" }}>
        <Stack spacing="gutter">
          <P>
            You will need to install the following records to complete the
            process
          </P>
          {data && (
            <Stack spacing="xl2">
              <Stack spacing={"xs2"}>
                <H5>Setup DKIM</H5>
                <Table
                  data={data.dnsConfigurationModels}
                  pagination={false}
                  columns={[
                    {
                      name: "Type",
                      grow: 0.3,
                      cell: row => <Text>{row.type}</Text>
                    },
                    {
                      name: 'HOST (some DNS hosts may refer to this as "Value")',
                      cell: row => <Text>{row.host}</Text>
                    },
                    {
                      name: 'VALUE (some DNS hosts may refer to this as "Points to")',
                      cell: row => <Text>{row.value}</Text>
                    }
                  ]}
                />
              </Stack>
              <Stack spacing={"xs2"}>
                <H5>Setup SPF</H5>
                <P>
                  Your SPF record to be setup to include our email solution. For
                  example like this
                </P>
                <Card>
                  <Box>
                    <Text>{data.senderPolicyFramework} </Text>
                  </Box>
                </Card>
              </Stack>
            </Stack>
          )}
        </Stack>
      </Card>
    </Page>
  );
};
